import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PusherPublicConfig {
  key: string;
  cluster: string;
  enabled: boolean;
}

export function usePusherConfig() {
  const { data, isLoading } = useQuery({
    queryKey: ["pusher-public-config"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_pusher_public_config" as any);
      if (error) throw error;
      return data as unknown as PusherPublicConfig;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });

  return {
    key: data?.key || "",
    cluster: data?.cluster || "",
    enabled: data?.enabled ?? false,
    loading: isLoading,
  };
}
